<div class="card">
	<div class="card-header">
		<h1>Categorías Registradas
			<i (click)="modal = true;"
					[tooltip]="'Crear'" class="fa fa-circle-plus text-info clickeable"></i>
		</h1>
	</div>
	<div class="card-body">
		<h5>Filtros</h5>
		<div class="row">
			<div class="col">
				<div class="form-group">
					<label for="list" class="form-label">Por lista:</label>
					<input type="text" (change)="filterCategories()" placeholder="Ingresa un nombre para buscar"
						id="list" name="list" class="form-control" [(ngModel)]="filterList">
				</div>
			</div>
			<div class="col">
				<div class="form-group">
					<label for="account" class="form-label">Por cuenta:</label>
					<select name="account" (change)="filterCategories()" id="account" class="form-select"
						[(ngModel)]="filterAccount">
						<option [ngValue]="-1">Todos</option>
						<option *ngFor="let a of allAccounts" [ngValue]="a.id">{{a.name}}</option>
					</select>
				</div>
			</div>
			<div class="col">
				<div class="form-group">
					<label for="status" class="form-label">Por estado:</label>
					<select name="status" (change)="filterCategories()" id="status" class="form-select"
						[(ngModel)]="filterStatus">
						<option [ngValue]="-1">Todos</option>
						<option [ngValue]="0">Pendientes</option>
						<option [ngValue]="1">Aprobados</option>
					</select>
				</div>
			</div>
			<div class="col">
				<div class="form-group">
					<label for="status" class="form-label">Por fecha:</label>
					<select name="status" id="status" (change)="filterCategories()" class="form-select"
						[(ngModel)]="filterDate">
						<option [ngValue]="0">Recientes->Anteriores</option>
						<option [ngValue]="1">Anteriores->Recientes</option>
					</select>
				</div>
			</div>
		</div>
		<div class="mt-3">
			<table class="table table-bordered" style="margin: 0;">
				<thead>
					<tr class="tr-middle title">
						<th>Nombre</th>
						<th>Cuenta asociada</th>
						<th>Fecha de Ingreso</th>
						<th>Estado</th>
						<th>Activado</th>
						<th class="no-border-td"></th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let c of pagination.filter" [ngClass]="c.active?'active':'inactive'"
						[class.hide-all]="toChange?.id==c.id">
						<td>
							{{c.name}}
						</td>
						<td>
							{{mapAllAccounts[c.accountId]?.displayId}} -
							{{mapAllAccounts[c.accountId]?.name}}
						</td>
						<td style="text-align: center;">
							<ng-container *ngIf="c.creationDate">
								{{c.creationDate | date: 'dd/MM/YYYY'}}
							</ng-container>
							<ng-container *ngIf="!c.creationDate">
								<div class="td-date">
									<div class="date-not-found">
										<i class="fa fa-calendar-days"></i>
										<i class="fa fa-question"></i>
									</div>
								</div>
							</ng-container>
						</td>
						<td style="text-align: center;">
							<span *ngIf="c.validated">
								Aprobado
							</span>
							<span *ngIf="!c.validated" style="font-size: 0.8em; opacity: 0.7;">
								Pendiente de confirmar
							</span>
						</td>
						<td style="text-align: center;">
							{{c.active? 'Sí':'No'}}
						</td>
						<td class="no-border-td option-tab" style="vertical-align: middle; text-align: center;">
							<div class="icon-group">
								<i class="fa fa-edit clickeable text-info" tooltip="Editar"
									(click)="editCategory(c)"></i>
								<div class="container-superposition" title="Activar">
									<div class="element-superposition" *ngIf="toChange?.id == c.id">
										<span class="text-info">¿Deseas {{c.active?'eliminar':'activar'}} la categoria
											{{toChange.name}}?</span>
										<div class="a-container">
											<div class="clickeable"
												(click)="toChange.changing = false; toChange = null;">
												<i class="fa fa-ban"></i>NO
											</div>
											<div class="clickeable text-success" (click)="changeCategory()"><i
												[ngClass]="c.active?'fa-trash':'fa-power-off'" class="fa"></i>SÍ
											</div>
										</div>
									</div>
									<span class="clickeable" [ngClass]="c.active?'text-danger':'text-danger'">
										<i *ngIf="!c.changing" [ngClass]="c.active?'fa-trash':'fa-power-off'" class="fa"
											(click)="toChange = c"></i>
										<span *ngIf="c.changing" class="spinner-border spinner-border-sm"
											aria-hidden="true"></span>
									</span>
								</div>
								<i *ngIf="!c.validated && !c.validating"
									class="fa-regular fa-circle-check clickeable text-success" tooltip="Validar"
									(click)="aprove(c)"></i>
								<app-loading-animation *ngIf="c.validating" [height]="'1em'"
									color="green"></app-loading-animation>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<app-pagination-custom [elements]="pagination"></app-pagination-custom>
	</div>
</div>
<div class="hide-background" *ngIf="toChange">
	<div class="for-click" (click)="toChange.changing = false; toChange = null;"></div>
</div>
<app-modal-expense-category *ngIf="modal" [allAccounts]="allAccounts" [edit]="toEdit" (close)="closeModal($event)"></app-modal-expense-category>